(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vip-reward-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = () => {
      document.querySelectorAll('[data-vip-reward-products]').forEach(setup);
    };

    const setup = (root) => {
      if (root.__vipInitialized) return;
      root.__vipInitialized = true;

      const grid = root.querySelector('[data-vip-grid]');
      const template = root.querySelector('[data-vip-card-template]');
      const status = root.querySelector('[data-vip-status]');
      const statusText = root.querySelector('[data-vip-status-text]');
      const loggedIn = root.dataset.customerLoggedIn === 'true';
      const loginUrl = root.dataset.loginUrl;
      const apiOrigin = root.dataset.apiOrigin;
      const pointMin = parseInt(root.dataset.pointMin, 10) || 0;
      const pointMax = parseInt(root.dataset.pointMax, 10) || 10000;
      const pageSize = parseInt(root.dataset.pageSize, 10) || 50;
      const successMessage = root.dataset.successMessage;

      const parseJson = (sel, fallback) => {
        const el = root.querySelector(sel);
        if (!el) return fallback;
        try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
      };
      const i18n = parseJson('[data-vip-i18n]', {});
      const t = (key, fallback) => (i18n[key] != null && i18n[key] !== '') ? i18n[key] : fallback;
      // 3桁カンマ区切り（ロケール非依存でカンマ固定）
      const fmtNum = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const rewardTranslations = {};
      parseJson('[data-vip-reward-translations]', []).forEach((tr) => {
        if (tr && tr.id) rewardTranslations[tr.id] = tr;
      });
      // 品名・説明の翻訳は en のみ（reward_translation の title_en/description_en、案Aの意図的スコープ）。多言語化時は locale 別フィールド化する
      const locale = (root.dataset.locale || '').toLowerCase();
      const useRewardTranslations = locale.indexOf('en') === 0;

      const showStatus = (text, type) => {
        status.hidden = false;
        statusText.textContent = text;
        status.dataset.type = type || 'info';
      };

      const showLoading = () => {
        grid.innerHTML = '';
        const div = document.createElement('div');
        div.className = 'c-vip-reward-products__loading';
        div.textContent = t('loading', '読み込み中...');
        grid.appendChild(div);
      };

      const showEmpty = (message) => {
        grid.innerHTML = '';
        const div = document.createElement('div');
        div.className = 'c-vip-reward-products__empty';
        div.textContent = message;
        grid.appendChild(div);
      };

      const showError = (message) => {
        grid.innerHTML = '';
        const div = document.createElement('div');
        div.className = 'c-vip-reward-products__error';
        div.textContent = message;
        grid.appendChild(div);
      };

      const waitForSDK = () => new Promise((resolve, reject) => {
        if (window.VipApp && window.VipApp.VIPAppSDK) return resolve(window.VipApp);
        let waited = 0;
        const t = setInterval(() => {
          if (window.VipApp && window.VipApp.VIPAppSDK) {
            clearInterval(t);
            resolve(window.VipApp);
          } else if ((waited += 100) > 8000) {
            clearInterval(t);
            reject(new Error('SDK timeout'));
          }
        }, 100);
      });

      const render = (nodes) => {
        if (!nodes || nodes.length === 0) {
          showEmpty(t('empty', '交換できるアイテムがありません。'));
          return;
        }
        const pointSuffix = t('point_suffix', ' ポイント');
        const labelLogin = t('login_to_redeem', 'ログインして交換');
        const labelRedeem = t('redeem', 'ポイント交換');
        const labelInsufficient = t('insufficient_points', 'ポイント不足');
        const fragment = document.createDocumentFragment();
        nodes.forEach((node) => {
          const card = template.content.cloneNode(true);
          const tr = useRewardTranslations ? rewardTranslations[node.id] : null;
          const cardTitle = (tr && tr.title) || node.title || '';
          const cardDescription = (tr && tr.description) || node.description || '';
          const img = card.querySelector('[data-vip-image]');
          if (node.image && node.image.url) {
            img.src = node.image.url;
            img.alt = cardTitle;
          } else {
            img.remove();
          }
          card.querySelector('[data-vip-title]').textContent = cardTitle;
          card.querySelector('[data-vip-description]').textContent = cardDescription;
          card.querySelector('[data-vip-point]').textContent = fmtNum(node.point != null ? node.point : 0) + pointSuffix;
          const btn = card.querySelector('[data-vip-trade-button]');
          if (!loggedIn) {
            btn.textContent = labelLogin;
            btn.addEventListener('click', () => {
              const returnTo = window.location.pathname + window.location.search;
              const sep = loginUrl.indexOf('?') >= 0 ? '&' : '?';
              window.location.href = loginUrl + sep + 'checkout_url=' + encodeURIComponent(returnTo);
            });
          } else if (node.hasCustomerEnoughPoint) {
            btn.textContent = labelRedeem;
            btn.disabled = false;
            btn.addEventListener('click', () => trade(node.id, btn));
          } else {
            btn.textContent = labelInsufficient;
            btn.disabled = true;
          }
          fragment.appendChild(card);
        });
        grid.innerHTML = '';
        grid.appendChild(fragment);
      };

      const trade = async (rewardId, btn) => {
        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = t('processing', '処理中...');
        try {
          await sdk.customerRewardTrade({ rewardRuleID: rewardId });
          showStatus(successMessage, 'success');
          await load();
        } catch (e) {
          console.error('[vip-reward-products] trade failed', e);
          showStatus(t('trade_failed', '交換に失敗しました。時間をおいて再度お試しください。'), 'error');
          btn.disabled = false;
          btn.textContent = originalText;
        }
      };

      let sdk = null;
      const load = async () => {
        showLoading();
        try {
          if (!sdk) {
            const vipApp = await waitForSDK();
            sdk = new vipApp.VIPAppSDK(apiOrigin);
          }
          const res = await sdk.rewards(pageSize, null, pointMin, pointMax);
          const nodes = res && res.rewardRules && res.rewardRules.nodes ? res.rewardRules.nodes : [];
          render(nodes);
        } catch (e) {
          console.error('[vip-reward-products]', e);
          showError(t('error', '読み込みに失敗しました。ページを再読み込みしてください。'));
        }
      };

      load();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
